// The inline "get the template" gate on each individual template page
// (/templates-and-forms/<slug>/). Same job as template_downloads.js's modal
// on the hub page, but embedded in the hero instead of popped over it —
// someone who landed here from a search result has nothing else on screen
// to gate.

import { submitLead } from "./brevo_lead.js"

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

export function setupTemplateGate() {
  const gate = document.querySelector("[data-template-gate]")
  if (!gate) return

  const form = gate.querySelector("[data-gate-form-el]")
  const formPanel = gate.querySelector("[data-gate-form]")
  const success = gate.querySelector("[data-gate-success]")
  const errorBanner = gate.querySelector("[data-gate-error]")
  const templateName = gate.dataset.templateName
  const templatePdf = gate.dataset.templatePdf

  form.addEventListener("submit", (event) => {
    event.preventDefault()

    const data = Object.fromEntries(new FormData(form).entries())
    const capacity = parseInt(data.capacity, 10)
    const valid =
      (data.first || "").trim() &&
      (data.last || "").trim() &&
      EMAIL_RE.test((data.email || "").trim()) &&
      (data.center || "").trim() &&
      capacity > 0

    if (!valid) {
      errorBanner.hidden = false
      return
    }
    errorBanner.hidden = true

    submitLead({
      first: data.first.trim(),
      last: data.last.trim(),
      email: data.email.trim(),
      center: data.center.trim(),
      capacity: String(capacity),
      template: templateName,
      templateUrl: new URL(templatePdf, window.location.origin).href,
    })

    formPanel.hidden = true
    success.hidden = false
  })
}
